import { fetchCurrentUser, fetchCurrentUserHasListingsThunk } from '../../ducks/user.duck';

/**
 * Always refresh own listings on Account → Profile. A skipped lookup
 * used to render “not set up” for listeners who already have a listing.
 *
 * @returns {Function}
 */
export const loadData = () => dispatch =>
  Promise.resolve(dispatch(fetchCurrentUser({ updateNotifications: false }))).then(() =>
    dispatch(fetchCurrentUserHasListingsThunk())
  );
